export default "__VITE_ASSET__BEEJhynW__"